/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  DURATION_NIGHT: 'DURATION_NIGHT',
  DURATION_DAY: 'DURATION_DAY',
  DURATION_HOUR: 'DURATION_HOUR',
  DURATION_MIN: 'DURATION_MIN',
  DISTANCE_LIMIT_KILOMETER: 'DISTANCE_LIMIT_KILOMETER',
  DISTANCE_LIMIT_MILES: 'DISTANCE_LIMIT_MILES'
}; export default Keys;